// Tier 2 jobs - role becomes explicit. Default axes (Lv-only unlock) +
// special axes (Lv + item/quest). See docs/03-jobs-skills §3.4, ADR 0005 §2.2,
// ADR 0006 §2.1.
//
// All growth bands follow the HHMLL pattern (sum_value = 5.0). H placement
// covers the job's Type-primary stats; M is the next-relevant attribute; L
// is the off-Type pair. See ADR 0006 §2.1.1 / §2.1.2 for the invariants.
// --- Default axes (Lv-only unlock, escalator base) ---
export const JOB_KNIGHT = {
    id: 'knight',
    name: '騎士',
    tier: 2,
    types: ['Tank'],
    growth: { str: 'high', dex: 'mid', int: 'low', vit: 'high', wis: 'low' },
    ultimateSkillId: 'ult.knight.bulwark',
};
export const JOB_MAGE = {
    id: 'mage',
    name: '魔法使い',
    tier: 2,
    types: ['MagicDPS'],
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.mage.spell-blast',
};
export const JOB_CLERIC = {
    id: 'cleric',
    name: '神官',
    tier: 2,
    types: ['Healer'],
    growth: { str: 'low', dex: 'low', int: 'mid', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.cleric.benediction',
};
export const JOB_ASSASSIN = {
    id: 'assassin',
    name: '暗殺者',
    tier: 2,
    types: ['MeleeDPS'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.assassin.shadow-step',
};
export const JOB_BOWMASTER = {
    id: 'bowmaster',
    name: '弓使い',
    tier: 2,
    types: ['RangedDPS'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.bowmaster.eagle-eye',
};
export const JOB_BARD = {
    id: 'bard',
    name: '吟遊詩人',
    tier: 2,
    types: ['Support'],
    growth: { str: 'low', dex: 'high', int: 'mid', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.bard.heroic-chorus',
};
// --- Special axes (Lv + item/quest unlock, no T3 escalator endpoint) ---
export const JOB_SAMURAI = {
    id: 'samurai',
    name: '侍',
    tier: 2,
    types: ['MeleeDPS'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.samurai.counter-stance',
};
export const JOB_SUMMONER = {
    id: 'summoner',
    name: '召喚士',
    tier: 2,
    types: ['Summoner'],
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.summoner.dual-sigil',
};
export const JOB_BEAST_TAMER = {
    id: 'beast-tamer',
    name: '獣使い',
    tier: 2,
    types: ['Summoner'],
    growth: { str: 'mid', dex: 'low', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.beast-tamer.warden-howl',
};
export const JOB_PHANTOM_THIEF = {
    id: 'phantom-thief',
    name: '怪盗',
    tier: 2,
    types: ['MeleeDPS', 'Support'],
    growth: { str: 'mid', dex: 'high', int: 'low', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.phantom-thief.heist-time',
};
export const JOB_ASCETIC_MONK = {
    id: 'ascetic-monk',
    name: '修道士',
    tier: 2,
    types: ['Healer', 'Support'],
    growth: { str: 'low', dex: 'low', int: 'mid', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.ascetic-monk.self-sacrifice',
};
export const JOBS_TIER2 = [
    // Default axes (6)
    JOB_KNIGHT,
    JOB_MAGE,
    JOB_CLERIC,
    JOB_ASSASSIN,
    JOB_BOWMASTER,
    JOB_BARD,
    // Special axes (5)
    JOB_SAMURAI,
    JOB_SUMMONER,
    JOB_BEAST_TAMER,
    JOB_PHANTOM_THIEF,
    JOB_ASCETIC_MONK,
];
//# sourceMappingURL=tier2.js.map